// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"arrow-right-up"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8.2719 8L16.0501 8V15.7782M15.1706 8.87946L8.02441 16.0257","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ArrowRightUpIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'arrow-right-up',
    ref,
    icon: element,
  },
));

ArrowRightUpIcon.displayName = 'ArrowRightUpIcon';

export default ArrowRightUpIcon;
